var map = {
	"./Friday.mp3": 2214,
	"./Monday.mp3": 7680,
	"./Saturday.mp3": 8186,
	"./Sunday.mp3": 2555,
	"./Thursday.mp3": 2606,
	"./Tuesday.mp3": 9939,
	"./Wednesday.mp3": 7983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4341;